const HashtagEngagementReport = {

	visual: {
		icon: "va-icon fa fa-line-chart",
		title: "Hashtag engagement report",
		desc: "Analysis of multiple hashtag engagement."
	},

	binding: [
	{"engagement_array_string": "array","label":"Hashtag(s)"},
	{"hashtag_engagement_limit": "number", "label":"Hashtag Limit"},
	{"status_created_at_from": "date", "label":"Hashtag used from"},
	{"status_created_at_to": "date", "label":"Hashtag used to"}
	],

	query:`
	MATCH 
		(h:Hashtag)-[r1:HASHTAG_OF]->(s:Status)-[r2:RETWEETED_BY | :POSTED_BY]->(a:Account) 
	WHERE 
		date(s.created_at) >= date(':status_created_at_from') AND date(s.created_at) <= date(':status_created_at_to')
	AND
		h.text IN :engagement_array_string
	RETURN 
		h, a, s , r1, r2 
	LIMIT 
		:hashtag_engagement_limit
	`,

	config:{
		console_debug:false,
		labels: {
			"Hashtag": {
				"caption": "hashtag"
			},
			"Account":{
				"caption": "screen_name"
			},
			"Status": {
				"caption": false
			}
		},
		relationships: {
			"POSTED_BY": {
				"caption": "POSTED_BY"
			},
			"RETWEETED_BY": {
				"caption": "RETWEETED_BY"
			},
			"HASHTAG_OF": {
				"caption": "HASHTAG_OF"
			}
		},
	}
	
}

export default HashtagEngagementReport;
